import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'VisibilityWrapper',
  props: {
    condition: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'visibility-wrapper': true,
            'visibility-wrapper--hidden': !__props.condition,
        })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})